import { AfterContentChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SectionWiseService } from '../../../service/section-wise.service';
import { SwProcessPageUiService } from '../../../service/ui/sw-process-page-ui.service';
import { SwProcessStateService } from '../../../service/ui/sw-process-state.service';
import { AbTestConfigModel } from 'src/app/shared/models/start-up-config/abtest-config-model';
import { ApplicationConstant } from 'src/app/application.constant';
import { AppConfigurationService } from 'src/app/app-configuration.service';

@Component({
  selector: 'sw-modify-top',
  templateUrl: './sw-modify-top.component.html'
})
export class SwModifyTopComponent implements AfterContentChecked, OnInit {
  public sectionErrorIndexes: string;
  public baseImageUrl: string;
  private abTestConfig: AbTestConfigModel = ApplicationConstant.abTestConfig;

  constructor(
    private swProcessPageUiService: SwProcessPageUiService,
    private swProcessStateService: SwProcessStateService,
    private sectionWiseService: SectionWiseService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private appConfigService: AppConfigurationService
  ) {}

  public ngAfterContentChecked() {
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    if (this.appConfigService.getURLConfig?.baseImageUrl) {
      this.baseImageUrl = this.appConfigService.getURLConfig.baseImageUrl;
    }
  }

  public submit(): void {
    this.swProcessStateService.submitSwInput(this.abTestConfig);
  }

  public openDiscard(): void {
    this.swProcessPageUiService.openSwDiscardModal({ isActive: true, isMainDiscard: true });
    this.sectionWiseService.setDiscardModalOpen(true);
  }

  public isFormModified(): boolean {
    return this.swProcessStateService.isContractModified();
  }

  public isSectionHasError() {
    if (!this.swProcessStateService.isHealthContractLoaded()) {
      return false;
    }

    if (this.sectionWiseService.sectionDetailsModel.filter((s) => s.IsError).length > 0) {
      this.sectionErrorIndexes = this.sectionWiseService.sectionDetailsModel
        .filter((s) => s.IsError)
        .map((m) => m.SerialNumber)
        .filter((v, i, a) => a.indexOf(v) === i)
        .toString();
      return true;
    }
    return false;
  }
}
